import { Icon, Link, TooltipDelay, TooltipHost } from "office-ui-fabric-react";
import './UserReleaseNotifications.css';

const ReleaseNotificationsLink = 'https://share-eu1.hsforms.com/1YYOgvlllSCy9ZhczBlQC8gfw3hq';

const UserReleaseNotifications = ({ email, company }: { email: string, company: string }) => {
    return <div className="release-notifications">
        <Link 
            className="text-link" 
            href={`${ReleaseNotificationsLink}?email=${email}&company=${company}`} 
            target="_blank">
                Subscribe to release notifications
        </Link>
        <TooltipHost
            delay={TooltipDelay.zero}
            closeDelay={TooltipDelay.long}
            content={'Follow the link to fill out the form if you would like to receive an email notification with an extended features overview a few days before the upcoming release.'}>
                <Icon iconName="Info" />
        </TooltipHost>
    </div>
}

export default UserReleaseNotifications;